import { SBCAAS_CLASSIC_LABEL } from '@/constants/sbcaas';

export const maxRedundancyOptions = [
    {
        name: '1',
        value: 1,
    },
    {
        name: '2',
        value: 2,
    },
    {
        name: '3',
        value: 3,
    },
    {
        name: '4',
        value: 4,
    },
];

export const toastSuccess = {
    title: 'Service updated successfully',
    status: 'success',
    duration: 3000,
    isClosable: true,
    description: `${SBCAAS_CLASSIC_LABEL} has been updated!`,
};
